import React from 'react';
import facebook from '../../assests/facebook.png';
import google from '../../assests/google.png';
import zillow from '../../assests/zillow.png';

const ReviewComponent = ({
  getData, handleReviewActivity, setPage, page, typePage,
}) => (
  <div className="qs-fade-in space-y-8">
    <div className="space-y-3">
      <div className="qs-title">
        {getData?.template === ('' || null) ? <span>{getData?.heading}</span> : <span>{getData?.template.review_heading}</span>}
      </div>
      {getData?.template === ('' || null)
        ? (
          <div className="qs-subtitle mx-auto max-w-[480px]">
            {getData?.body}
          </div>
        )
        : (
          <div className="qs-subtitle mx-auto max-w-[480px]">
            {getData?.template?.review_body}
          </div>
        )}
    </div>
    {(getData?.template !== '' || getData?.template !== null) && (
      <div className="space-y-3">
        {getData?.template?.company_id === '774565dd-fd5f-46ee-911f-e0b07f707f8a' && (
          <div className="flex justify-center empty:hidden">
            <button
              className="qs-btn"
              type="button"
              style={{
                backgroundColor: getData?.template?.review_site_button_color,
                color: getData?.template?.review_site_button_text_color,
              }}
            >
              <a href="https://www.zillow.com/reviews/write?s=X1-ZU12k3ztu0mxsll_4lr3f">
                <div className="flex items-center justify-center gap-3">
                  <img
                    src={zillow}
                    alt={zillow}
                    className="h-6 w-6 shrink-0 rounded-md bg-white object-contain p-0.5"
                  />
                  <span>
                    Review us on
                    {' '}
                    Zillow
                  </span>
                </div>
              </a>
            </button>
          </div>
        )}
        <div className="flex justify-center empty:hidden">
          {getData?.template?.review_site_1_url !== null && (
            <button
              className="qs-btn"
              type="button"
              style={{
                backgroundColor: getData?.template?.review_site_button_color,
                color: getData?.template?.review_site_button_text_color,
              }}
              onClick={() => handleReviewActivity(getData?.template?.review_site_1_platform)}
            >
              <a href={getData?.template?.review_site_1_url}>
                <div className="flex items-center justify-center gap-3">
                  <img
                    src={google || getData?.logo_1}
                    alt={getData?.template?.review_site_1_platform}
                    className="h-6 w-6 shrink-0 rounded-md bg-white object-contain p-0.5"
                  />
                  <span>
                    Review us on
                    {' '}
                    {getData?.template?.review_site_1_platform}
                  </span>
                </div>
              </a>
            </button>
          )}
        </div>

        <div className="flex justify-center empty:hidden">
          {getData?.template?.review_site_2_url !== null && (
            <button
              className="qs-btn"
              type="button"
              style={{
                backgroundColor: getData?.template?.review_site_button_color,
                color: getData?.template?.review_site_button_text_color,
              }}
              onClick={() => handleReviewActivity(getData?.template?.review_site_2_platform)}
            >
              <a href={getData?.template?.review_site_2_url}>
                <div className="flex items-center justify-center gap-3">
                  <img
                    src={facebook || getData?.logo_2}
                    alt={getData?.template?.review_site_2_platform}
                    className="h-6 w-6 shrink-0 rounded-md bg-white object-contain p-0.5"
                  />
                  <span>
                    Review us on
                    {' '}
                    {getData?.template?.review_site_2_platform}
                  </span>
                </div>
              </a>
            </button>
          )}
        </div>

        <div className="flex justify-center empty:hidden">
          {getData?.template?.review_site_3_url !== null && (
            <button
              className="qs-btn"
              type="button"
              style={{
                backgroundColor: getData?.template?.review_site_button_color,
                color: getData?.template?.review_site_button_text_color,
              }}
              onClick={() => handleReviewActivity(getData?.template?.review_site_3_platform)}
            >
              <a href={getData?.template?.review_site_3_url}>
                <div className="flex items-center justify-center gap-3">
                  <img
                    src="data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'%3e%3crect width='512' height='512' style='fill:%23d32323'/%3e%3cpath d='M248.32,74.24c-1.28-4.69-5.12-8.11-10.24-9.81-16.21-4.27-79.36,13.65-90.88,26-3.84,3.84-5.12,9-3.84,13.23,1.71,3.84,79.79,128.43,79.79,128.43,11.52,18.77,20.9,16.21,23.89,14.93,3-.85,12.37-3.84,11.52-26C256.85,195,249.17,79.79,248.32,74.24ZM214.61,308.05c6.4-1.7,10.67-7.68,11.1-14.93.42-7.68-3.42-14.51-9.82-17.07L198,268.8c-61-25.6-63.57-26.45-66.56-26.45-4.69-.43-9,2.13-11.94,6.82-6,9.82-8.54,41.39-6.4,62.3.85,6.82,2.13,12.8,3.84,16.21,2.56,4.69,6.4,7.68,11.09,7.68,3,0,4.69-.43,61.44-18.77Zm32,23.47c-6.82-3-14.5-1.28-18.77,4.27l-12.37,14.93c-42.67,51.2-44.38,53.33-45.66,56.32a12.66,12.66,0,0,0-.85,5.55,11.5,11.5,0,0,0,3.41,7.68c9.82,11.94,57.18,29.86,72.54,27.3A13.06,13.06,0,0,0,255.57,439c.86-3,1.28-5.12,1.28-65.28V346.45C257.71,340.05,253.44,334.08,246.61,331.52Zm148.48,12c-2.56-1.71-4.26-2.56-61-21.34,0,0-24.75-8.53-25.17-8.53-6-2.56-12.8-.43-17.5,5.55s-5.54,13.65-1.7,19.62l9.81,16.64c33.71,55.47,36.27,59.31,38.4,61.44,3.84,3,8.53,3.42,13.65,1.28,14.51-6,45.66-46.08,47.79-61.86C400.21,351.15,398.93,346.45,395.09,343.47Zm-91.3-63.15c9-1.71,82.34-19.2,88.32-23.47,3.84-2.56,6-7.25,5.54-12.8v-.42c-1.7-16.22-29.44-58-43.09-64.86-4.69-2.13-9.81-2.13-13.65.43-2.56,1.71-4.27,4.27-38.83,52.05L286.29,253c-4.26,5.12-4.26,12.38,0,18.78C290.56,278.61,294.83,282,303.79,280.32Z' style='fill:%23fff'/%3e%3c/svg%3e"
                    alt={getData?.template?.review_site_3_platform}
                    className="h-6 w-6 shrink-0 rounded-md bg-white object-contain p-0.5"
                  />
                  <span>
                    Review us on
                    {' '}
                    {getData?.template?.review_site_3_platform}
                  </span>
                </div>
              </a>
            </button>
          )}
        </div>

        <div className="flex justify-center empty:hidden">
          {getData?.template?.review_site_4_url !== null && (
            <button
              className="qs-btn"
              type="button"
              style={{
                backgroundColor: getData?.template?.review_site_button_color,
                color: getData?.template?.review_site_button_text_color,
              }}
              onClick={() => handleReviewActivity(getData?.template?.review_site_4_platform)}
            >
              <a href={getData?.template?.review_site_4_url}>
                <div className="flex items-center justify-center gap-3">
                  <img
                    src="data:image/png;base64,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"
                    alt={getData?.template?.review_site_4_platform}
                    className="h-6 w-6 shrink-0 rounded-md bg-white object-contain p-0.5"
                  />
                  <span>
                    Review us on
                    {' '}
                    {getData?.template?.review_site_4_platform}
                  </span>
                </div>
              </a>
            </button>
          )}
        </div>
        <div className="flex justify-center empty:hidden">
          {getData?.template?.review_site_5_url !== null && (
            <button
              className="qs-btn"
              type="button"
              style={{
                backgroundColor: getData?.template?.review_site_button_color,
                color: getData?.template?.review_site_button_text_color,
              }}
              onClick={() => handleReviewActivity(getData?.template?.review_site_5_platform)}
            >
              <a href={getData?.template?.review_site_5_url}>
                <div className="flex items-center justify-center gap-3">
                  <img
                    src={(getData?.template?.company_id === 'ce1a569a-f91b-4f11-9562-4970e07a8b1f' || localStorage.getItem('sc_comp_id') === 'c2b14ccf-7a41-4300-be9c-d86846e7d9e7') ? 'https://s3.us-east-2.amazonaws.com/sc-prod-embedded.salescaptain.com/resources/2024-10-11/images_1728628522821.png' : 'https://s3.us-east-2.amazonaws.com/sc-prod-embedded.salescaptain.com/resources/2024-10-11/217450_1728628523249.png'}
                    alt={getData?.template?.review_site_5_platform}
                    className="h-6 w-6 shrink-0 rounded-md bg-white object-contain p-0.5"
                  />
                  <span>
                    Review us on
                    {' '}
                    {getData?.template?.review_site_5_platform}
                  </span>
                </div>
              </a>
            </button>
          )}
        </div>

      </div>
    )}
    {typePage !== 'cx' && (
      <div className="space-y-3 border-t border-slate-100 pt-6">
        <div className="w-full text-center text-sm text-slate-500">
          {getData?.template === ('' || null) ? getData?.contact_message : getData?.template?.contact_message}
        </div>

        <div className="flex justify-center empty:hidden">
          {getData?.template?.contact_us_flag && (
            <button
              type="button"
              className="qs-btn"
              style={{
                backgroundColor:
                  getData?.template?.contact_button_color,
                color: getData?.template?.contact_button_text_color,
              }}
              onClick={() => setPage(page + 1)}
            >
              {getData?.template?.contact_button_text}
              {' '}
            </button>
          )}
        </div>
      </div>
    )}
  </div>

);

export default ReviewComponent;
